import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { Organization } from "@App/types";
import { BulletPoint } from "@App/Components/common/BulletPoint";
import {
  BonusBenefitsIcon,
  CalendarCheckBenefitsIcon,
  CheckBenefitsIcon,
} from "@App/Components/common/Icons";
import { FeedbackHint } from "@App/Components/Partials/FeedbackHint";

type BenefitsProps = {
  organization: Organization;
};

export const Benefits: FunctionComponent<BenefitsProps> = (props: BenefitsProps) => {
  const { t } = useTranslation();

  return (
    <div className="md:pr-12">
      <div className="footerBlockHeadline font-serif text-2xl mb-4">{t("benefits.title")}</div>
      {t("benefits.bullet-point-1", { organization: props.organization.name }) && (
        <BulletPoint text={t("benefits.bullet-point-1", { organization: props.organization.name })}>
          <CalendarCheckBenefitsIcon />
        </BulletPoint>
      )}
      {t("benefits.bullet-point-2", { organization: props.organization.name }) && (
        <BulletPoint text={t("benefits.bullet-point-2", { organization: props.organization.name })}>
          <CheckBenefitsIcon />
        </BulletPoint>
      )}
      {t("benefits.bullet-point-3", { organization: props.organization.name }) && (
        <BulletPoint text={t("benefits.bullet-point-3", { organization: props.organization.name })}>
          <BonusBenefitsIcon />
        </BulletPoint>
      )}
      <div className={"mt-8"}>
        <FeedbackHint />
      </div>
    </div>
  );
};
